export const debtConsolidationData = [
  {
    id: 1,
    heading:
      "Personal Loan Debt Consolidation Calculator: Simplify Your Repayments",
    subHeading:
      "Managing multiple personal loans from different apps or lenders can quickly become overwhelming. With Minemi’s Personal Loan Debt Consolidation Calculator, you can streamline your repayments into one manageable loan, reduce your monthly payments, and save money by consolidating at a lower interest rate.",
    notice:
      "Minemi’s Personal Loan Debt Consolidation Calculator simplifies debt management and helps you save money. Start planning today to regain control of your financial future!",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];

export const stepsOfDebtConsolidation = [
  {
    id: "step-one",
    stepName: "Understand Personal Loan Debt Consolidation",
  },
  {
    id: "step-two",
    stepName: "Evaluate Your Current Financial Situation",
  },
  {
    id: "step-three",
    stepName: "Identify Eligible Personal Loans for Consolidation",
  },
  {
    id: "step-four",
    stepName: "Use Minemi’s Personal Loan Debt Consolidation Calculator",
  },
  {
    id: "step-five",
    stepName: "Compare Consolidation Loan Offers",
  },

  {
    id: "step-six",
    stepName: "Apply for a Personal Loan Debt Consolidation Loan",
  },
  {
    id: "step-seven",
    stepName: "Close Existing Personal Loans",
  },
  {
    id: "step-eight",
    stepName: "Effectively Manage the New Loan",
  },
  {
    id: "step-nine",
    stepName: "Monitor and Improve Your Credit Score",
  },
];
